import styled from 'styled-components';
import { GridCol } from '@m/alchemy-ui/GridCol';
import { units } from '@m/alchemy-ui/theme';

export const GridColWithMargin = styled(GridCol)`
  margin-bottom: ${units(3)};
`;
